<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="DED1"><span class="ePub-I">To my parents (Jack and Connie McShulskis) and my children (Paige and Jack Harbison), who have always made Christmas magical in my life.</span></p>
<p class="DED"><span class="ePub-I">Also, in memory of John Harbison, with whom I shared many magical holidays.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?3b485a3c